import { Err } from '@sniptt/monads';
export const timeout = (promise, timeoutMs, fallbackValue) => {
    return Promise.race([
        promise,
        new Promise(resolve => setTimeout(() => {
            resolve(fallbackValue);
        }, timeoutMs)),
    ]);
};
export const timeoutMonadic = (promise, timeoutMs, timeoutRight) => {
    return Promise.race([
        promise,
        new Promise(resolve => setTimeout(() => {
            resolve(Err(timeoutRight));
        }, timeoutMs)),
    ]);
};
